import React from "react";
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';

import {
  Dialog, DialogActions, 
  DialogContent, DialogContentText, 
  DialogTitle
} from '@material-ui/core';

import Button from "../buttons/button.js";

import I18n from "../i18n.js";

const styles = theme => ({
  yes: {

  },
  no: {
    backgroundColor: theme.palette.redError
  }
});

class ModalConfirm extends React.Component {

  constructor(props) {
    super(props);
    this.state = {

    }

    this.bodyRef = React.createRef();


    this.confirm = this.confirm.bind(this);
  }

  static getDerivedStateFromProps(props, state) {
    return {
      open: props.open
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return this.state.open !== nextState.open;
  }
  
  confirm() {
    const { close, onConfirm } = this.props;
    if(onConfirm) {
      onConfirm();
    }
    close();
  }

  render() {
    const { 
      classes, 
      title, message, 
      close, onClose
    } = this.props;
    const { open } = this.state;

    return <Dialog open = { open } 
                   onClose = { onClose }
                   scroll = { "paper" } >
    <DialogTitle>
      { title }
    </DialogTitle>
    <DialogContent dividers = { true } >
      <DialogContentText ref = { this.bodyRef } >
        {
          message
        }
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick = { close }
              className = { classes.no } >
        { I18n.t("shared.no_text") }
      </Button>
      <Button onClick = { this.confirm }
              className = { classes.yes } >
        { I18n.t("shared.yes_text") }
      </Button>
    </DialogActions>
  </Dialog>
  }
}

export default withStyles(styles)(ModalConfirm);